export default "__VITE_ASSET__DkITZTaB__"